import CuttingJobs from '@/views/CuttingJobs/Index.vue'

export default [
    {
        path: '/cutting-jobs',
        name: 'cuttingJobs',
        redirect: { name: 'cuttingJobsList' },
        component: CuttingJobs,
        meta: {
            title: 'cuttingJobs.menuTitle',
            menuRendered: true,
            menuTitle: 'cuttingJobs.menuTitle',
            requiresAuth: true,
            permission: 'cutting_jobs',
            icon: 'mdi-content-cut'
        },
        children: [
            {
                path: '',
                name: 'cuttingJobsList',
                component: () => import('@/views/CuttingJobs/CuttingJobs/Index.vue'),
                meta: {
                    title: 'cuttingJobs.pageTitle',
                    requiresAuth: true,
                    permission: 'cutting_jobs'
                }
            }
        ]
    }
]
